/* POSTIFULL v101 (2026-11-01) - Urun sayfasi musteri yorumu fotografi: ayni sayfada buyuk foto + yorum + yakinlastirma.
   Tetik: #musteri-yorumlari .pfp-card__img (sonradan yuklenen kartlar dahil). Stil: assets/pf-rv-lightbox.css
   Masaustu: fotoga tikla = 2.5x yakinlastir, fare ile gez; oklar / klavye ile onceki-sonraki; Esc kapatir.
   Telefon: cift dokun = yakinlastir, iki parmakla buyut, yakinlasinca surukle; yana kaydir = sonraki, asagi kaydir = kapat. */
(function () {
  'use strict';
  if (window.__pfRvLb) return;
  window.__pfRvLb = true;

  var SEL = '#musteri-yorumlari .pfp-card__img';
  var lb, img, stage, wrap, els = {}, list = [], idx = 0;
  var z = { s: 1, x: 0, y: 0 };

  function big(src) { return (src || '').replace(/\/mnresize\/-\/\d+\//, '/mnresize/-/1200/'); }
  function star(on) { return '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" class="' + (on ? 'on' : '') + '"><path d="M12 2.6l2.9 6.1 6.6.8-4.9 4.6 1.3 6.6L12 17.4l-5.9 3.3 1.3-6.6-4.9-4.6 6.6-.8z"/></svg>'; }
  function txt(card, s) { var e = card.querySelector(s); return e ? e.textContent.trim() : ''; }

  function build() {
    lb = document.createElement('div');
    lb.className = 'pfrv';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-label', 'Müşteri fotoğrafı ve yorumu');
    lb.hidden = true;
    lb.innerHTML =
      '<div class="pfrv__bg" data-x></div>' +
      '<div class="pfrv__box">' +
        '<div class="pfrv__stage">' +
          '<div class="pfrv__wrap"><img class="pfrv__img" alt="Müşteri fotoğrafı" draggable="false"></div>' +
          '<button type="button" class="pfrv__nav pfrv__nav--p" data-p aria-label="Önceki fotoğraf"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg></button>' +
          '<button type="button" class="pfrv__nav pfrv__nav--n" data-n aria-label="Sonraki fotoğraf"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg></button>' +
          '<span class="pfrv__hint" data-hint></span>' +
          '<button type="button" class="pfrv__zoom" data-z aria-label="Yakınlaştır"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5M11 8v6M8 11h6" data-zp/></svg></button>' +
        '</div>' +
        '<aside class="pfrv__panel">' +
          '<div class="pfrv__head"><span class="pfrv__av" data-av></span><span class="pfrv__who"><b data-name></b><span class="pfrv__ver" data-ver></span></span></div>' +
          '<div class="pfrv__stars" data-stars></div>' +
          '<p class="pfrv__text" data-text></p>' +
          '<div class="pfrv__foot" data-foot><span class="pfrv__tip" data-tip></span></div>' +
        '</aside>' +
        '<button type="button" class="pfrv__close" data-x aria-label="Kapat"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M6 6l12 12M18 6 6 18"/></svg></button>' +
      '</div>';
    document.body.appendChild(lb);
    img = lb.querySelector('.pfrv__img');
    stage = lb.querySelector('.pfrv__stage');
    wrap = lb.querySelector('.pfrv__wrap');
    ['av', 'name', 'ver', 'stars', 'text', 'foot', 'hint', 'tip'].forEach(function (k) { els[k] = lb.querySelector('[data-' + k + ']'); });
    var touch = matchMedia('(hover: none)').matches;
    els.hint.textContent = touch ? 'Yakınlaştırmak için iki kez dokunun' : 'Yakınlaştırmak için fotoğrafa tıklayın';
    els.tip.textContent = touch ? '' : '← → ile gezinin';
    if (touch) els.foot.hidden = true;

    lb.addEventListener('click', function (e) {
      if (e.target.closest('[data-x]')) return close();
      if (e.target.closest('[data-p]')) return go(-1);
      if (e.target.closest('[data-n]')) return go(1);
      if (e.target.closest('[data-z]')) return z.s > 1 ? reset() : zoomAt(2.5, 0.5, 0.5);
    });
    // masaustu: tikla = yakinlastir, fare ile gez
    wrap.addEventListener('click', function (e) {
      if (touch) return;
      var r = wrap.getBoundingClientRect();
      if (z.s > 1) reset(); else zoomAt(2.5, (e.clientX - r.left) / r.width, (e.clientY - r.top) / r.height);
    });
    wrap.addEventListener('mousemove', function (e) {
      if (touch || z.s <= 1) return;
      var r = wrap.getBoundingClientRect();
      panTo((e.clientX - r.left) / r.width, (e.clientY - r.top) / r.height);
    });
    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') go(-1);
      else if (e.key === 'ArrowRight') go(1);
    });
    touchInit();
  }

  function apply(anim) {
    img.style.transition = anim ? 'transform .25s ease' : 'none';
    img.style.transform = 'translate(' + z.x + 'px,' + z.y + 'px) scale(' + z.s + ')';
    lb.classList.toggle('is-zoom', z.s > 1.01);
  }
  function clampXY() {
    var w = wrap.clientWidth, h = wrap.clientHeight;
    var mx = (w * (z.s - 1)) / 2, my = (h * (z.s - 1)) / 2;
    z.x = Math.max(-mx, Math.min(mx, z.x));
    z.y = Math.max(-my, Math.min(my, z.y));
  }
  function zoomAt(s, fx, fy) {
    z.s = s;
    z.x = (0.5 - fx) * wrap.clientWidth * (s - 1);
    z.y = (0.5 - fy) * wrap.clientHeight * (s - 1);
    clampXY(); apply(true);
  }
  function panTo(fx, fy) {
    z.x = (0.5 - fx) * wrap.clientWidth * (z.s - 1);
    z.y = (0.5 - fy) * wrap.clientHeight * (z.s - 1);
    clampXY(); apply(false);
  }
  function reset() { z.s = 1; z.x = 0; z.y = 0; apply(true); }

  function load(u) {
    // yorum fotografi JPEG olarak yuklenir (yon duzeltmesi: assets/pf-rv-orient.js); hazir olunca cozulur
    var get = window.pfRvJpeg ? window.pfRvJpeg(u).catch(function () { return u; }) : Promise.resolve(u);
    return get.then(function (src) {
      return new Promise(function (res) {
        var t = new Image();
        t.onload = t.onerror = function () { res(src); };
        t.src = src;
      });
    });
  }
  function show(i, dir) {
    idx = (i + list.length) % list.length;
    var card = list[idx].closest('.pfp-card') || list[idx].parentElement;
    var u = big(list[idx].dataset.pfSrc || list[idx].getAttribute('src'));
    lb.dataset.cur = u;
    var name = txt(card, '.pfp-card__name') || 'Postifull müşterisi';
    els.av.textContent = name.charAt(0);
    els.name.textContent = name;
    els.ver.textContent = txt(card, '.pfp-card__ver');
    var p = Math.round(parseFloat(card.getAttribute('data-puan')) || 5), s = '';
    for (var k = 1; k <= 5; k++) s += star(k <= p);
    els.stars.innerHTML = s;
    els.stars.setAttribute('aria-label', '5 üzerinden ' + p + ' yıldız');
    els.text.textContent = txt(card, '.pfp-card__text');
    lb.classList.toggle('is-single', list.length < 2);
    lb.classList.add('is-loading');
    load(u).then(function (src) {
      if (lb.dataset.cur !== u) return;
      z.s = 1; z.x = 0; z.y = 0;
      img.style.transition = 'none';
      img.style.opacity = '0';
      img.style.transform = dir ? 'translateX(' + (dir * 36) + 'px)' : 'none';
      img.src = src;
      lb.classList.remove('is-zoom', 'is-loading');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          img.style.transition = 'transform .22s ease, opacity .22s ease';
          img.style.opacity = '1';
          img.style.transform = 'translate(0px,0px) scale(1)';
        });
      });
    });
  }
  function go(d) { if (list.length > 1) show(idx + d, d); }
  function open(el) {
    if (!lb) build();
    list = Array.prototype.filter.call(document.querySelectorAll(SEL), function (x) { return x.offsetParent !== null; });
    if (!list.length) list = [el];
    img.removeAttribute('src');
    show(Math.max(0, list.indexOf(el)));
    lb.hidden = false;
    document.documentElement.classList.add('pfrv-lock');
    requestAnimationFrame(function () { lb.classList.add('is-open'); });
    lb.querySelector('.pfrv__close').focus({ preventScroll: true });
  }
  function close() {
    lb.classList.remove('is-open');
    document.documentElement.classList.remove('pfrv-lock');
    setTimeout(function () { lb.hidden = true; img.removeAttribute('src'); }, 180);
  }

  // telefon: cift dokunma = yakinlastir, iki parmak = buyut, yakinken surukle;
  // normal boyutta yon kilitli kaydirma: yatay = onceki/sonraki, asagi = kapat
  function touchInit() {
    var t0 = null, lastTap = 0, pinch = null, bg = lb.querySelector('.pfrv__bg');
    function dist(a, b) { return Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY); }
    function setDrag(x, y) {
      img.style.transition = 'none';
      img.style.transform = 'translate(' + x + 'px,' + y + 'px)';
      img.style.opacity = y > 0 ? String(Math.max(0.35, 1 - y / 400)) : '1';
      bg.style.opacity = y > 0 ? String(Math.max(0.3, 1 - y / 300)) : '';
    }
    function back() {
      img.style.transition = 'transform .2s ease, opacity .2s ease';
      img.style.transform = 'translate(0px,0px) scale(1)';
      img.style.opacity = '1';
      bg.style.transition = 'opacity .2s ease'; bg.style.opacity = '';
      setTimeout(function () { bg.style.transition = ''; }, 220);
    }
    // arkadaki sayfa kaymasin (iOS); yorum paneli kendi icinde kayabilir
    lb.addEventListener('touchmove', function (e) {
      if (!e.target.closest('.pfrv__panel') && e.cancelable) e.preventDefault();
    }, { passive: false });
    stage.addEventListener('touchstart', function (e) {
      if (e.target.closest('button')) { t0 = null; return; }
      if (e.touches.length === 2) {
        pinch = { d: dist(e.touches[0], e.touches[1]), s: z.s };
        t0 = null; return;
      }
      var t = e.touches[0];
      t0 = { x: t.clientX, y: t.clientY, zx: z.x, zy: z.y, axis: null };
    }, { passive: true });
    stage.addEventListener('touchmove', function (e) {
      if (pinch && e.touches.length === 2) {
        if (e.cancelable) e.preventDefault();
        z.s = Math.max(1, Math.min(4, pinch.s * dist(e.touches[0], e.touches[1]) / pinch.d));
        clampXY(); apply(false); return;
      }
      if (!t0 || e.touches.length !== 1) return;
      var t = e.touches[0], dx = t.clientX - t0.x, dy = t.clientY - t0.y;
      if (!t0.axis) {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        t0.axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      }
      if (e.cancelable) e.preventDefault();
      if (z.s > 1) { z.x = t0.zx + dx; z.y = t0.zy + dy; clampXY(); apply(false); return; }
      if (t0.axis === 'x') setDrag(list.length > 1 ? dx : dx * 0.25, 0);
      else setDrag(0, Math.max(0, dy));
    }, { passive: false });
    function end(e) {
      if (pinch) { if (!e.touches || e.touches.length < 2) { pinch = null; if (z.s < 1.05) reset(); } return; }
      if (!t0) return;
      var t = e.changedTouches[0], dx = t.clientX - t0.x, dy = t.clientY - t0.y, s = t0;
      t0 = null;
      if (!s.axis) {
        var now = Date.now();
        if (now - lastTap < 300) {
          lastTap = 0;
          var r = wrap.getBoundingClientRect();
          if (z.s > 1) reset(); else zoomAt(2.5, (t.clientX - r.left) / r.width, (t.clientY - r.top) / r.height);
        } else lastTap = now;
        return;
      }
      lastTap = 0;
      if (z.s > 1) return;
      if (s.axis === 'x' && Math.abs(dx) > 50 && list.length > 1) {
        var d = dx < 0 ? 1 : -1;
        img.style.transition = 'transform .16s ease, opacity .16s ease';
        img.style.transform = 'translateX(' + (dx < 0 ? -1 : 1) * stage.clientWidth * 0.6 + 'px)';
        img.style.opacity = '0';
        setTimeout(function () { go(d); }, 140);
        return;
      }
      if (s.axis === 'y' && dy > 110) { bg.style.opacity = ''; close(); return; }
      back();
    }
    stage.addEventListener('touchend', end);
    stage.addEventListener('touchcancel', end);
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var el = e.target.closest(SEL);
    // fotografli yorum kartinin herhangi bir yerine tiklamak da pencereyi acar
    if (!el) {
      var card = e.target.closest('#musteri-yorumlari .pfp-card');
      if (card && !e.target.closest('a, button')) el = card.querySelector('.pfp-card__img');
    }
    if (!el) return;
    e.preventDefault();
    open(el);
  });
})();
